module.exports = __webpack_public_path__ + "img/arrow-down-gray.d090aa7e.svg";